import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

const fetchBrainTreeToken = async (signal: AbortSignal) => {
	const signalOptions = signal ? { signal } : undefined;

	try {
		const resp = await getAndValidate(
			apiRoutes.GETBRAINTREETOKEN,
			z.string(),
			signalOptions,
		);
		if (resp.success) {
			return resp.data.replaceAll('"', "");
		} else {
			console.error("Failed to fetch Braintree token:", resp.error);
			return null;
		}
	} catch (error) {
		console.error("Failed to fetch Braintree token:", error);
		return null;
	}
};

export const useGetBraintreeToken = () => {
	const { data, isLoading, error } = useQuery({
		queryKey: ["braintreeToken"],
		queryFn: async ({ signal }) => {
			return await fetchBrainTreeToken(signal);
		},
		staleTime: 0,
		gcTime: 0,
	});
	return {
		token: data,
		isLoading,
		error,
	};
};
